import { useContext } from "react"
import { GlobalContext } from "../../../../App"
import Product from "../../../Product/Product"
import { BlackText, Container, FirstText, ProductsContainer, ProductWrapper, SecondText, TextContainer, ThirdText } from "./styles"

const WeekendDeals = () => {
  const globalContext = useContext(GlobalContext)

  const mapProducts = () => {
    return (
      globalContext.homeProducts['favs_of_comparers'] && globalContext.homeProducts['favs_of_comparers'].map((product, index) => (
        <ProductWrapper>
          <Product singleModeView={true} product={product} isFavorite={false} highlight={true} />
        </ProductWrapper>
      ))
    )
  }
  return (
    <Container>
      <TextContainer>
        <FirstText>favoritos</FirstText>
        <SecondText>De los {'\0'}<BlackText>Comparers</BlackText></SecondText>
        <ThirdText>No te pierdas estas oportunidades</ThirdText>
      </TextContainer>
      <ProductsContainer>
        {mapProducts()}
      </ProductsContainer>
    </Container>
  )
}

export default WeekendDeals